import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = ["src"]

import { PlusOutlined } from '@ant-design/icons-vue';
import { ref, watch } from 'vue';
import type { UploadProps } from 'ant-design-vue';
import { cloneDeep } from "lodash-es"

export default /*@__PURE__*/_defineComponent({
  __name: 'upload-image',
  props: {
    maxCount: {
        type: Number,
        default: 1
    },
    disabled: {
        type: Boolean,
        default: false
    }
},
  emits: ["file-change"],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

function getBase64(file: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const fileList = ref<UploadProps['fileList']>([
]);

watch(() => fileList.value, async (Val) => {
    const tempFile = []
    if (Val) {
        for (let i = 0; i < Val.length; i++) {
            //@ts-ignore
            const temp = await getBase64(Val[i])
            //@ts-ignore
            const tempBase = temp.split(",")
            if (tempBase.length > 1) {
                const copy = cloneDeep(tempBase[1])
                //@ts-ignore
                tempFile.push(copy)
            }
        }
    }
    emits("file-change", tempFile)
})

const handleCancel = () => {
    previewVisible.value = false;
    previewTitle.value = '';
};
//@ts-ignore
const handlePreview = async (file: UploadProps['fileList'][number]) => {
    if (!file.url && !file.preview) {
        file.preview = (await getBase64(file.originFileObj)) as string;
    }
    previewImage.value = file.url || file.preview;
    previewVisible.value = true;
    previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const beforeUpload: UploadProps['beforeUpload'] = file => {
    fileList.value = [...(fileList.value || []), file];
    return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const img: HTMLImageElement = document.createElement('img');
            img.src = reader.result as string;
            // emits("file-change", reader.result)

        }
    })


};

const handleRemove: UploadProps['onRemove'] = file => {
    //@ts-ignore
    const index = fileList.value.indexOf(file);
    //@ts-ignore
    const newFileList = fileList.value.slice();
    newFileList.splice(index, 1);
    fileList.value = newFileList;
    // return new Promise(resolve => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onload = () => {
    //         const img: HTMLImageElement = document.createElement('img');
    //         img.src = reader.result as string;
    //         emits("file-change", reader.result)
    //     }
    // })

};

return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_upload, {
      "file-list": fileList.value,
      "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
      maxCount: __props.maxCount,
      "list-type": "picture",
      onPreview: handlePreview,
      onRemove: handleRemove,
      "before-upload": beforeUpload,
      disabled: __props.disabled
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(PlusOutlined))
        ])
      ]),
      _: 1
    }, 8, ["file-list", "maxCount", "disabled"]),
    _createVNode(_component_a_modal, {
      open: previewVisible.value,
      title: previewTitle.value,
      footer: null,
      onCancel: handleCancel
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          alt: "example",
          style: {"width":"100%"},
          src: previewImage.value
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["open", "title"])
  ]))
}
}

})